import React from "react";
import ReactDOM  from 'react-dom';
import { Redirect, withRouter } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import SessionManager from '../util/SessionManager'

class LoginLogout extends React.Component{

    render(){

        if(SessionManager.isUserLoggedIn){
            
            return (
                <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" href="!#" onClick={this.logout}>
                    <div className="preview-thumbnail">
                        <i className="mdi mdi-logout text-primary"></i>
                    </div>
                    <div className="preview-item-content py-2">
                        <Trans>Αποσύνδεση</Trans>
                    </div>
                </Dropdown.Item>
            );
        } 
        else {
            return(
                <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" href="!#" onClick={this.login}>
                    <div className="preview-thumbnail">
                        <i className="mdi mdi-logout text-primary"></i>
                    </div>
                    <div className="preview-item-content py-2">
                        <Trans>Σύνδεση</Trans>
                    </div>
                </Dropdown.Item>
            );
        }
    }

    logout() {
        SessionManager.logout();
        return ( <Redirect to="/login" /> );
    }

    login() {
        return ( <Redirect to="/login" /> );
    }
}

export default withRouter(LoginLogout);